module.exports = __webpack_public_path__ + "static/media/KZT.9a60e437.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/currencies/KZT.svg
// module id = 2367
// module chunks = 7